module.exports = __webpack_public_path__ + "img/TZS09706.4bfe5286.jpeg";